/* =====================================================================
   Maeve & Co — PDP refinement layer (v11)
   1. Size chips show the UK size only ("2XL · UK 16" -> "UK 16")
   2. Sizes sorted small -> large, not in supplier order
   3. Every button-style option echoes its choice in its label
      ("Colour: Red Stripe", "Size: UK 8"); size also echoes in the button
   4. Slim sticky mobile buy bar once the real button scrolls away
   5. Estimated delivery dates, from the data-* values on
      [data-maeve-delivery] in snippets/price.liquid. The element with
      [data-maeve-eta] receives the date range only ("Wed 30 Sept – Sun 4 Oct").
      data-days="calendar" counts every day (weekends included);
      anything else counts Mon–Fri only. Orders after the cut-off hour
      (London time) count from the next day.
   Re-runs itself whenever Dawn re-renders the buy column.
   ===================================================================== */
(function () {
  'use strict';

  var UK_RE = /^\s*(.+?)\s*[·•|/-]\s*(UK\s*\d+\s*\S*)\s*$/i;
  var URGENT_HOURS = 6;
  var CALENDAR_DAYS = false;
  var info = null;
  var bar = null;
  var io = null;
  var raf = 0;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(id) { return (window.CSS && CSS.escape) ? CSS.escape(id) : id; }
  function isSize(el) { return /size/i.test((el && el.getAttribute('data-option-name')) || ''); }
  function cleanValue(v) { var m = String(v || '').trim().match(UK_RE); return m ? m[2] : String(v || '').trim(); }

  /* ---------- 1. Size chip labels ---------- */
  function cleanSizeLabels() {
    qa('.product-form__input--pill input[type="radio"]', info).forEach(function (input) {
      if (!isSize(input)) return;
      var label = info.querySelector('label[for="' + esc(input.id) + '"]');
      if (!label || label.hasAttribute('data-mv-clean')) return;

      var full = (input.value || '').trim();
      var m = full.match(UK_RE);
      if (!m) { label.setAttribute('data-mv-clean', ''); return; }

      for (var i = 0; i < label.childNodes.length; i++) {
        var n = label.childNodes[i];
        if (n.nodeType === 3 && n.nodeValue.trim()) { n.nodeValue = m[2]; break; }
      }
      label.setAttribute('title', full);
      label.setAttribute('aria-label', full);
      label.setAttribute('data-mv-clean', '');
    });
  }

  /* ---------- 2. Sizes in size order ---------- */
  function sizeKey(value) {
    var m = String(value).match(/UK\s*(\d+)/i);
    if (m) return parseInt(m[1], 10);
    var word = String(value).trim().toUpperCase();
    var order = { XXS: 1, XS: 2, S: 3, M: 4, L: 5, XL: 6, XXL: 7, '2XL': 7, XXXL: 8, '3XL': 8, '4XL': 9, '5XL': 10 };
    return order[word] || null;
  }

  function sortSizes() {
    qa('.product-form__input--pill', info).forEach(function (fs) {
      var inputs = qa('input[type="radio"]', fs);
      if (inputs.length < 2 || !isSize(inputs[0])) return;

      var pairs = [];
      for (var i = 0; i < inputs.length; i++) {
        var k = sizeKey(inputs[i].value);
        if (k === null) return;
        var lab = fs.querySelector('label[for="' + esc(inputs[i].id) + '"]');
        if (!lab) return;
        pairs.push({ k: k, input: inputs[i], label: lab });
      }

      var sorted = pairs.slice().sort(function (a, b) { return a.k - b.k; });
      if (sorted.every(function (p, i) { return p.input === pairs[i].input; })) return;

      sorted.forEach(function (p) { fs.appendChild(p.input); fs.appendChild(p.label); });
    });
  }

  /* ---------- helpers ---------- */
  function selectedSize() {
    var hit = null;
    qa('.product-form__input input[type="radio"]:checked, .product-form__input select', info).forEach(function (el) {
      var named = el.getAttribute('data-option-name') ||
        (el.selectedOptions && el.selectedOptions[0] && el.selectedOptions[0].getAttribute('data-option-name')) || '';
      if (!/size/i.test(named)) return;
      hit = cleanValue(el.value);
    });
    return hit;
  }

  function currentPrice() {
    var el = q('.price__sale .price-item--sale, .price__regular .price-item--regular, .price .price-item', info);
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function realButton() { return q('.product-form__submit', info); }

  /* ---------- 3a. Chosen value in every button-option label ----------
     The value span goes INSIDE the name span: the legend is a flex row with a
     gap, so a sibling would render as "Size  : UK 16". */
  function labelSelectedValues() {
    qa('.product-form__input--pill > legend', info).forEach(function (legend) {
      var fs = legend.parentNode;
      var checked = fs.querySelector('input[type="radio"]:checked');
      var anchor = legend.querySelector('span');
      if (!anchor) return;

      if (!anchor.hasAttribute('data-mv-name')) {
        anchor.setAttribute('data-mv-name', anchor.textContent.replace(/\s+/g, ' ').replace(/:\s*$/, '').trim());
      }
      var base = anchor.getAttribute('data-mv-name') || '';
      var want = checked ? ': ' + cleanValue(checked.value) : '';
      var out = anchor.querySelector('[data-selected-value]');

      var haveBase = (anchor.firstChild && anchor.firstChild.nodeType === 3) ? anchor.firstChild.nodeValue : null;
      if (haveBase === base && (out ? out.textContent : '') === want) return;

      anchor.textContent = base;
      if (want) {
        out = document.createElement('span');
        out.setAttribute('data-selected-value', '');
        out.textContent = want;
        anchor.appendChild(out);
      }
    });
  }

  /* ---------- 3b. Chosen size echoed in the button ---------- */
  function echoSelection() {
    var btn = realButton();
    if (!btn || btn.disabled) return;
    var span = btn.querySelector('span');
    if (!span) return;
    if (!span.hasAttribute('data-mv-base')) {
      span.setAttribute('data-mv-base', span.textContent.replace(/\s+/g, ' ').trim());
    }
    var base = span.getAttribute('data-mv-base') || 'Add to cart';
    var size = selectedSize();
    var want = size ? '  ·  ' + size : '';
    var echo = span.querySelector('.mv-atc-echo');

    var haveBase = (span.firstChild && span.firstChild.nodeType === 3) ? span.firstChild.nodeValue : null;
    if (haveBase === base && (echo ? echo.textContent : '') === want) return;

    span.textContent = base;
    if (want) {
      echo = document.createElement('span');
      echo.className = 'mv-atc-echo';
      echo.textContent = want;
      span.appendChild(echo);
    }
  }

  /* ---------- 5. Estimated delivery dates ---------- */
  function londonNow() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
      }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return new Date(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
    } catch (e) {
      return new Date();
    }
  }
  function isWorkday(d) {
    if (CALENDAR_DAYS) return true;
    var w = d.getDay();
    return w !== 0 && w !== 6;
  }
  function addWorkdays(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); if (isWorkday(r)) n--; }
    return r;
  }
  function dayMon(d) { return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric' }); }
  function monOnly(d) { return d.toLocaleDateString('en-GB', { month: 'short' }); }
  function fmtRange(a, b) {
    return monOnly(a) === monOnly(b)
      ? dayMon(a) + ' – ' + dayMon(b) + ' ' + monOnly(b)
      : dayMon(a) + ' ' + monOnly(a) + ' – ' + dayMon(b) + ' ' + monOnly(b);
  }
  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  function renderDelivery() {
    var root = q('[data-maeve-delivery]');
    if (!root) return;

    CALENDAR_DAYS = root.getAttribute('data-days') === 'calendar';
    var pmin = parseInt(root.getAttribute('data-proc-min'), 10) || 2;
    var pmax = parseInt(root.getAttribute('data-proc-max'), 10) || 2;
    var smin = parseInt(root.getAttribute('data-ship-min'), 10) || 4;
    var smax = parseInt(root.getAttribute('data-ship-max'), 10) || 9;
    var cut = parseInt(root.getAttribute('data-cutoff'), 10);
    if (isNaN(cut)) cut = 18;

    var now = londonNow();
    var openToday = isWorkday(now) && now.getHours() < cut;
    var base = openToday ? new Date(now.getTime()) : addWorkdays(now, 1);

    var eta = root.querySelector('[data-maeve-eta]');
    if (eta) {
      var want = fmtRange(addWorkdays(base, pmin + smin), addWorkdays(base, pmax + smax));
      if (eta.textContent !== want) eta.textContent = want;
    }

    var meta = root.querySelector('[data-maeve-cutoff]');
    if (meta) {
      var html;
      if (openToday) {
        var ms = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cut, 0, 0) - now;
        var h = Math.floor(ms / 3600000);
        var m = Math.floor((ms % 3600000) / 60000);
        html = h >= URGENT_HOURS
          ? 'Order before <b>' + pad2(cut) + ':00</b> to be packed today'
          : 'Order within <b>' + (h > 0 ? h + 'h ' : '') + m + 'm</b> to be packed today';
      } else {
        html = 'Packed from <b>' + dayMon(base) + ' ' + monOnly(base) + '</b>';
      }
      if (meta.innerHTML !== html) meta.innerHTML = html;
    }
  }

  /* ---------- 4. Sticky buy bar ---------- */
  function buildBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'mv-stickybuy';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');

    var img = q('.product__media img, .product-media-container img', info);
    var titleEl = q('.product__title h1, .maeve-ptitle__name, h1', info);

    bar.innerHTML =
      (img ? '<img class="mv-stickybuy__thumb" src="' + (img.currentSrc || img.src) + '" alt="" aria-hidden="true">' : '') +
      '<div class="mv-stickybuy__meta">' +
      '<p class="mv-stickybuy__name"></p>' +
      '<p class="mv-stickybuy__sub"></p>' +
      '</div>' +
      '<button type="button" class="mv-stickybuy__btn"></button>';

    bar.querySelector('.mv-stickybuy__name').textContent =
      titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';

    bar.querySelector('.mv-stickybuy__btn').addEventListener('click', function () {
      var b = realButton();
      if (b && !b.disabled) b.click();
    });

    document.body.appendChild(bar);
    return bar;
  }

  function syncBar() {
    if (!bar) return;
    var b = realButton();
    var btn = bar.querySelector('.mv-stickybuy__btn');
    var sub = bar.querySelector('.mv-stickybuy__sub');

    var wantSub = [selectedSize(), currentPrice()].filter(Boolean).join('  ·  ');
    if (sub.textContent !== wantSub) sub.textContent = wantSub;

    var wantLabel, wantDisabled;
    if (!b || b.disabled) {
      wantLabel = 'Sold out';
      wantDisabled = true;
    } else {
      var real = b.querySelector('span[data-mv-base]');
      wantLabel = real ? real.getAttribute('data-mv-base') : 'Add to cart';
      wantDisabled = false;
    }
    if (btn.textContent !== wantLabel) btn.textContent = wantLabel;
    btn.disabled = wantDisabled;
  }

  function watchBar() {
    var anchor = q('.product-form__buttons', info);
    if (!anchor || !('IntersectionObserver' in window)) return;
    if (io) io.disconnect();
    io = new IntersectionObserver(
      function (entries) {
        var e = entries[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      },
      { threshold: 0, rootMargin: '0px 0px -8% 0px' }
    );
    io.observe(anchor);
  }

  /* ---------- run ---------- */
  function decorate() {
    if (!info) return;
    cleanSizeLabels();
    sortSizes();
    echoSelection();
    labelSelectedValues();
    renderDelivery();
    syncBar();
  }

  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () { raf = 0; decorate(); watchBar(); });
  }

  function init() {
    info = q('product-info') || q('.product__info-wrapper');
    if (!info || !q('.product-form__submit', info)) return;

    buildBar();
    decorate();
    watchBar();

    info.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(info, { childList: true, subtree: true });
    window.addEventListener('pageshow', schedule);
    setInterval(renderDelivery, 30000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
